// Formats a date as "DD.MM.YYYY" (Swiss/French style), e.g. a Date or ISO
// string -> "07.10.2026". Uses local-time getters (consistent with the
// toLocaleDateString calls it replaces). Empty/invalid input is handled
// gracefully so it is safe to call on arbitrary cell values:
//   null/undefined/'' -> ''
//   unparseable        -> the original value as a string
export const formatDate = (value: any): string => {
  if (value === null || value === undefined || value === '') {
    return '';
  }
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) {
    return String(value);
  }
  const dd = String(d.getDate()).padStart(2, '0');
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const yyyy = String(d.getFullYear()).padStart(4, '0');
  return `${dd}.${mm}.${yyyy}`;
};
